import {GraphFiltersValues} from '@modules/graph-mathia/core/model/graph-filters-values';
import {ProgressDataEntity} from '@modules/graph-mathia/core/model/progress-data-entity';

export abstract class GraphData {
    public constructor(public graphFilters: Partial<GraphFiltersValues>, public entities: ProgressDataEntity[]) {
    }
}
